import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Forgetpass from './auth/Forgetpass';
import Disabled from './panel/Disabled';
import Notfound from './panel/Notfound';
import Help from './panel/Help';
import Dashboard from './components/reservatoins/Dashboard';

import Reserveroom from './components/reservatoins/Reserveroom';
import Viewreservations from './components/reservatoins/Viewreservations';
import Reservationdetails from './components/reservatoins/Reservationdetails';
import Checkouts from './components/reservatoins/Checkouts';
import Hotelinvoice from './components/reservatoins/Hotelinvoice';
import Roomcleaned from './components/reservatoins/Roomcleaned';
import Roomcleanings from './components/reservatoins/Roomcleaning';
import Selfreport from './components/reports/Selfreport';
import Checkoutreport from './components/reports/Checkoutreport';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });


  return (
    <div className="wrapper">
      {
        !user ?
          <Router>
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              <Route path='/Register' element={<Register />} />
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
          </Router>
          :
          <>
            <Header />
            <Router>
              <Routes>
                <Route path='/checkout-alert' element={<Checkoutreport />} />
                <Route path='/self-report' element={<Selfreport />} />
                <Route path='/cleaned-rooms' element={<Roomcleaned />} />
                <Route path='/cleaning-rooms' element={<Roomcleanings />} />
                <Route path='/print-invoice/:documentId' element={<Hotelinvoice />} />
                <Route path='/checkouts' element={<Checkouts />} />
                <Route path='/reservation-details/:documentId' element={<Reservationdetails />} />
                <Route path='/view-reservations' element={<Viewreservations />} />
                <Route path='/reservation' element={<Reserveroom />} />
                <Route path='*' element={<Notfound />} />
                <Route path='/' element={<Roomcleanings />} />
                <Route path='/home' element={<Roomcleanings />} />
                <Route path='/help-support' element={<Help />} />
              </Routes>
            </Router>
            <Footer />
          </>
      }


    </div >
  );
}

export default App;
